 
import Form from 'react-bootstrap/Form';
import SignIn from './SignIn' 
function Login() {
return (
<Form as="div" className="login-bg">
    <Form as="div" className="login-container w-50 p-5">       
      <SignIn/>
    </Form>
</Form>
);
}
export default Login;